module.exports = __webpack_public_path__ + "img/SK.2da42d80.svg";